import React from 'react';
import PropTypes from 'prop-types';
import { AButtonIndicator } from '../atoms';


export default class MLanguagePicker extends React.Component {
	constructor(props) {
		super(props);
		this.bindHandles();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	bindHandles() {
		this.handleWrapperRef = this.handleWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleSelectLanguage = this.handleSelectLanguage.bind(this);
	}

	handleWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.props.clickOutSide && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.clickOutSide();
		}
	}

	handleSelectLanguage({ language }) {
		if (this.props.onClick) {
			this.props.onClick(language);
		}
	}

	render() {
		return (
			<section className="a-tool-tip--top-right" ref={this.handleWrapperRef}>
				<AButtonIndicator
					value="NAVIGATION.LANGUAGE_DUTCH"
					icon="flag--belgium"
					className="width--unset"
					onClick={() => this.handleSelectLanguage({ language: 'nl' })}
				/>
				<AButtonIndicator
					value="NAVIGATION.LANGUAGE_FRENCH"
					icon="flag--french"
					className="width--unset"
					onClick={() => this.handleSelectLanguage({ language: 'fr' })}
				/>
			</section>
		);
	}
}

MLanguagePicker.propTypes = {
	clickOutSide: PropTypes.func.isRequired,
	onClick: PropTypes.func,
};

MLanguagePicker.defaultProps = {
	onClick: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.language-picker.js